import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router';
import { useQuery } from '../../hooks';
import { ejectToken, loadAuth } from '../../api';
export const AccessGate = () => {
    const { param: token } = useQuery('token');
    const nav = useNavigate();
    const ejected = ejectToken();
    if (ejected !== null && ejected !== '' && ejected !== undefined) {
        console.log('nav called');
        nav('/');
    }
    loadAuth({ token: token || '' });
    window.location.reload();
    return _jsx("div", {});
};
